import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.posts.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-posts-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.posts.item/view.scss */
/* src/app/page.posts.item/view.scss: no such file or directory */`],
})
export class PagePostsItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow()) {
            this.service.href("/algorithm");
            return;
        }
    }
}

export default PagePostsItemComponent;